import { Component, Injector, OnInit, ViewEncapsulation, NgZone, EventEmitter, Output } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AssetMasterServiceProxy, NotificationServiceProxy, UserNotification } from '@shared/service-proxies/service-proxies';
import { IFormattedUserNotification, UserNotificationHelper } from './UserNotificationHelper';
import * as _ from 'lodash';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { finalize } from 'rxjs/operators';

@Component({
    templateUrl: './header-notifications.component.html',
    selector: '[headerNotifications]',
    encapsulation: ViewEncapsulation.None
})
export class HeaderNotificationsComponent extends AppComponentBase implements OnInit {
@Output() openAssetModal = new EventEmitter<{
    assetId: number; 
    type: 'A' | 'R';
    userNotification?: IFormattedUserNotification
}>();

    notifications: IFormattedUserNotification[] = [];
    unreadNotificationCount = 0;

    constructor(
        injector: Injector,
        private _AssetMasterServiceProxy: AssetMasterServiceProxy,
        private _notificationService: NotificationServiceProxy,
        private _userNotificationHelper: UserNotificationHelper,
        public _zone: NgZone
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.loadNotifications();
        this.registerToEvents();
    }

    loadNotifications(): void {
        if (UrlHelper.isInstallUrl(location.href)) {
            return;
        }

        this._notificationService.getUserNotifications(undefined, 3, 0).subscribe(result => {
            this.unreadNotificationCount = result.unreadCount;
            this.notifications = [];
            _.forEach(result.items, (item: UserNotification) => {
                debugger;
                this.notifications.push(this._userNotificationHelper.format(<any>item));
            });
        });
    }

    registerToEvents() {
        let self = this;

        function onNotificationReceived(userNotification) {
            self._userNotificationHelper.show(userNotification);
            self.loadNotifications();
        }

        abp.event.on('abp.notifications.received', userNotification => {
            self._zone.run(() => {
                onNotificationReceived(userNotification);
            });
        });

        function onNotificationsRefresh() {
            self.loadNotifications();
        }

        abp.event.on('app.notifications.refresh', () => {
            self._zone.run(() => {
                onNotificationsRefresh();
            });
        });

        function onNotificationsRead(userNotificationId) {
            for (let i = 0; i < self.notifications.length; i++) {
                if (self.notifications[i].userNotificationId === userNotificationId) {
                    self.notifications[i].state = 'READ';
                }
            }

            self.unreadNotificationCount -= 1;
        }

        abp.event.on('app.notifications.read', userNotificationId => {
            self._zone.run(() => {
                onNotificationsRead(userNotificationId);
            });
        });
    }

    setAllNotificationsAsRead(): void {
        this._userNotificationHelper.setAllAsRead();
    }

    openNotificationSettingsModal(): void {
        this._userNotificationHelper.openSettingsModal();
    }

    setNotificationAsRead(userNotification: IFormattedUserNotification): void {
        debugger;
        this._userNotificationHelper.setAsRead(userNotification.userNotificationId);
    }

    // acknowledge(userNotification: IFormattedUserNotification): void {
    //         debugger;
    //         if(userNotification.data.properties.tranId){
    //         this._AssetMasterServiceProxy.acknowledgeAsset(Number(userNotification.data.properties.tranId))
    //               .pipe(finalize(() => {})).subscribe(() => {
    //                 this.setNotificationAsRead(userNotification);
    //                 this.notify.info(this.l('Acknowledge Sucessfully'));
    //               });
    //         }
    // }
    acknowledge(userNotification: IFormattedUserNotification): void {
  if (userNotification.data.properties.tranId) {
    this._AssetMasterServiceProxy
      .getAssetIdByTranId(Number(userNotification.data.properties.tranId))
      .subscribe(assetId => {
        if (assetId) {
          // Decide type based on notification
          const type = userNotification.text.includes('assigned') ? 'A' : 'R';

          // Call openAssetModal of topbar/header
this.openAssetModal.emit({ 
    assetId: assetId, 
    type: type,
    userNotification: userNotification // Pass the notification object
}); 

        }
      });
  }
}
    gotoUrl(url): void {
        debugger;
        if (url) {
            location.href = url;
        }
    }
}
